export const getTitle = (regionNames: Array<string>): string => {
  return regionNames.length > 1 ? 'Регионы' : 'Регион';
};
